/**
 * ComplianceFooter — compact single-line epi-guideline disclosure
 * rendered on every authenticated route. Surface: app shell
 * footer, above the existing AppFooter copyright line. Visible on
 * /matters, /matters/:id, /admin/prompts, and the four workspace
 * stages; NOT visible on unauthenticated routes (Login).
 *
 * Collapsed from the earlier two-paragraph block on feedback that
 * it ate too much vertical space. Same two semantic points
 * (diagnostic data available + client consent recommended),
 * joined by the " · " separator used elsewhere in the app as a
 * metadata delimiter so it reads as a sibling info strip rather
 * than a marketing banner.
 *
 * Zero interactivity, no dismiss, no border, no background —
 * intentionally minimal. Line wraps on narrow viewports to keep
 * the disclosure readable without forcing horizontal overflow.
 */
import React from 'react';


export default function ComplianceFooter({
  className = '',
}: {
  /** Optional class forwarding; defaults keep the footer subtle. */
  className?: string;
}) {
  return (
    <div
      data-testid="compliance-footer"
      className={
        'w-full text-[11px] text-zinc-400 text-center px-4 py-1 '
        + 'leading-snug '
        + className
      }
    >
      <span>Diagnostic data available for epi-guideline compliance review</span>
      <span className="mx-2" aria-hidden>·</span>
      <span>Client consent for AI-assisted drafting recommended</span>
    </div>
  );
}

